import { MdOutlineSubject } from "react-icons/md";

export const MoreDetailsIcon = ({ size = 23, ...props }) => {
  return <MdOutlineSubject size={size} {...props} />;
};
